/**
  * When added to the hidden input, this will update the crsf token
  * on form submit.
  *
  * Usage:
  *
  *   data-sw-csrf-updater="{id}"
  *      The id to be passed to the crsf generator
  *
  *   ex: <input data-sw-csrf-updater type="hidden" name="_csrf" value="*">
  *
  *  This module hijacks the submit event from any button or input[type="submit"] on the page
  *  that may submit the form that the csrf input is a member of. It uses a click event to
  *  capture the element that submit the form. It then updates the csrf, flags the csrf as
  *  updated and calls click() on that element to submit the form. This is done so that the
  *  form can wait for the csrf to be updated before submitting the form and any values
  *  attached to submit elements are still passed with the form.
  *
  *  If the form is submit by anything other than a click (like with js), the csrf is updated,
  *  the csrf is flagged as updated, and the form.submit() method is called.
  *
  *  Once the crsf update flag is true, the form submit event hijacker will return true
  *  so the form is submit.
  */

var $ = require('js/sw-jquery/sw-jquery');
var notifications = require('js/lib/notifications/sw-notifications');
var sw =  require('js/lib/sw');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-csrf-updater]').each(function() {
    var $el = $(this);
    var id = $el.data('swCsrfUpdater') || '';

    var csrfUpdated = false;
    var submitActor;

    function updateCsrf(cb) {
      $.swAjax({
        url: '/api/csrf-refresh',
        type: 'get',
        data: {
          id: id
        },
        success: function(data) {
         // Update the token on the page
         $el.val(data.csrfToken);
         if (typeof cb === "function") {
           cb();
         }
        },
        error: function() {
          notifications.error("There was a problem with your connection. Please try again.");
        }
      });
    }

    var form = $(this.form);
    function submitFormHandler() {
      // Do not intercept the form submit if the token has already been updated
      if (csrfUpdated) {
        return true;
      }
      updateCsrf(function () {
        // Flag the token as updated and click the button if one was clicked.
        csrfUpdated = true;
        if (submitActor) {
          submitActor.click();
        } else {
          form.submit();
        }
      });
      // Stop the form from being submit before the csrf token is updated
      return false;
    }

    var formId = form.attr('id') || '';
    // If an html5 button is used to submit the form, capture it
    if (formId) {
      $('body').on('click', ':submit[form="' + formId + '"]', function(e) {
        // Hijack the click event if the csrf has not been updated
        // since it will be click()ed after csrf update and we want to
        // kill other click handlers from happening twice.
        if (!csrfUpdated) {
          submitActor = $(e.target);
          submitFormHandler();
          return false;
        }
      });
    }
    // Capture elements in the form that could submit
    form.on('click', ':submit', function(e) {
      // Hijack the click event if the csrf has not been updated
      // since it will be click()ed after csrf update and we want to
      // kill other click handlers from happening twice.
      if (!csrfUpdated) {
        submitActor = $(e.target);
        submitFormHandler();
        return false;
      }
    });

    // Intercept any click event on a button, and update the csrf
    form.submit(submitFormHandler);

    sw.listenTo(sw, 'update-csrf-tokens', updateCsrf);

  });

};
